/**
 * Modelo de base para iframes dinámicos
 *
 * @export
 * @class Publicacion
 */

 export class Iframe {
   id?: number;
   nombre: string;
    url: string;
    propiedades?: string;
    activo: boolean;
 }


// WEBPACK FOOTER //
// ./src/app/shared/models/iframe.model.ts